import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../navbar.service';
import { LocalStorageService } from "ng2-webstorage";
import { Router } from "@angular/router";
import {AppConstants} from '../../../app.constants';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {

  schoolLogo: any;
  imgUrl: any;



  constructor(public navbarService: NavbarService,
              private localStorage: LocalStorageService,
              private router: Router,
              private appConstants: AppConstants) { }

  ngOnInit() {
    this.schoolLogo = this.localStorage.retrieve("logo");
    this.imgUrl = this.appConstants.fileDownloadUrl;
  }

  toggle() {
    console.log('hi');
    this.navbarService.toggleSideNav = !this.navbarService.toggleSideNav;
  }

  logOut(){
    this.localStorage.clear();
    this.router.navigate(["authentication/select-portal"]).then(() => {
      //window.location.reload();
    });
  }


}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/navbar/navbar.component.ts